import { render, staticRenderFns } from "./Register_YGHDB.vue?vue&type=template&id=32f67c85&scoped=true&"
import script from "./Register_YGHDB.js?vue&type=script&lang=js&"
export * from "./Register_YGHDB.js?vue&type=script&lang=js&"
import style0 from "./Register_YGHDB.vue?vue&type=style&index=0&id=32f67c85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f67c85",
  null
  
)

export default component.exports